import React, { useEffect, useContext } from "react";
import { useTranslation } from 'react-i18next';
import useForm from 'react-hook-form';
import ReactTable from "react-table";
import CsvDownloader from 'react-csv-downloader';


// @material-ui/core components
import TextField from '@material-ui/core/TextField';
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import Close from "@material-ui/icons/Close";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import { ValidSelect } from "beaktShared/helpers/validselect";
import Select from 'react-select';
import SnackbarContent from "beaktShared/components/Snackbar/SnackbarContent.js";
import { transformValueFloattoFormated } from "beaktShared/helpers/masks";
import CircularProgress from '@material-ui/core/CircularProgress';
import Tooltip from "@material-ui/core/Tooltip";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";

// icons
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import LocalAtmIcon from '@material-ui/icons/LocalAtm';
import CallMadeIcon from '@material-ui/icons/CallMade';
import MoneyOffIcon from '@material-ui/icons/MoneyOff';
import Assignment from '@material-ui/icons/Assignment';
import HistoryIcon from '@material-ui/icons/History';
import AccessTimeIcon from '@material-ui/icons/AccessTime';

// Outros components
import SweetAlert from "react-bootstrap-sweetalert";
import ExtratoRoyalties from "beaktMatriz/views/Royalties/ExtratoRoyalties.js";
import ExtratoRoyaltiesDM2 from "./ExtratoRoyaltiesDM2";
import Timeline from "beaktShared/components/Timeline/Timeline.js";
import Slide from "@material-ui/core/Slide";

// services
import { SessionContext } from "beaktShared/services/session";
import { UseGetApiSimple, UsePostApi } from "beaktShared/services/crudeApiService";
import { MaskMonthYear } from "beaktShared/helpers/masks";

// styles
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import { noCaseSensitive } from "beaktShared/helpers/extras";
import { formateDateandTime } from "beaktShared/helpers/masks";

const useStyles = makeStyles(styles);

const useConfirmStyles = makeStyles({
    buttonsRow: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        gap: '10px',
        '@media (max-width: 600px)': {
            flexDirection: 'column',
        },
    },
    actionButton: {
        fontSize: '1.25rem !important',
    },
    messageOverride: {
        '&.sweet-alert p': {
            fontSize: '1.25rem !important',
        },
    },
});

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

export default function ConfirmacaoPagamento() {
    const { t } = useTranslation();
    const session = useContext(SessionContext);
    const classes = useStyles();
    const confirmClasses = useConfirmStyles();

    const { register, setValue, errors, setError, clearError, getValues } = useForm({ mode: "onChange" });
    const [loading, setloading] = React.useState(false);

    const [notification, setNotification] = React.useState({
        show: false,
        color: 'info',
        message: ''
    });
    // Erro da API chega como objeto {status, statusDescription, message}; renderizar o objeto derruba a tela
    const textoMensagem = (message) =>
        typeof message === 'string' ? message : (message?.message || message?.statusDescription || '');

    const showNotification = (message, color) => {
        setNotification({
            show: true,
            color: color,
            message: textoMensagem(message)
        });
        setTimeout(function () {
            setNotification(prev => ({ ...prev, show: false }));
        }, 6000);
    };

    const [alert, setalert] = React.useState();
    const showAlert = (message, tipo) => {
        setalert(<SweetAlert
            error={tipo === 'error' ? true : false}
            warning={tipo === 'warning' ? true : false}
            success={tipo === 'success' ? true : false}
            title={t('label.warning')}
            onConfirm={() => setalert(null)}
        >
            {/* Texto puro: a mensagem pode vir da API (ex.: ex.Message em erro 500) e não deve ser interpretada como HTML */}
            <div>{textoMensagem(message)}</div>
        </SweetAlert>);
    };

    const [isLoadingEstabelecimento, setisLoadingEstabelecimento] = React.useState(false);
    const [estabelecimentos, setestabelecimentos] = React.useState([]);
    const [estabelecimento, setestabelecimento] = React.useState(0);
    const LoadEstabelecimentos = () => {
        setisLoadingEstabelecimento(true);
        const endPoint = "estabelecimentos/ativos/byfranquia/" + session.franquiaId;
        UseGetApiSimple(endPoint, 0).then(result => {
            if (result.status !== 200) {
                showNotification(result.message, 'error')
                setisLoadingEstabelecimento(false);
                return false;
            }

            let lista = [];
            lista = [{ estabelecimentoId: 0, descricao: "Todos" }, ...result.data];

            setisLoadingEstabelecimento(false);
            setestabelecimentos(lista);
            return true;
        });
    };
    const handleEstabelecimentoChange = event => {
        let value = event
        setestabelecimento(value);
        setValue("estabelecimento", value);
        if (value !== "")
            clearError("estabelecimento");
    };

    useEffect(() => {
        LoadEstabelecimentos();
    }, []);

    const [aceiteFechamento, setaceiteFechamento] = React.useState("Todos");
    const optionsAceiteFechamento = [
        { value: 'Todos', label: t('label.all') },
        { value: 'Aceito pela Clínica', label: t('royaltie.accepted_by_establishment') },
        { value: 'Pendente de Aceite', label: t('royaltie.pending_acceptance') },
        { value: 'Fechamento Estornado', label: t('royaltie.closure_reversed') },
    ]
    const handleAceiteFechamentoChange = (value) => {
        setaceiteFechamento(value);
    }

    const [situacaoFechamento, setsituacaoFechamento] = React.useState("Todos");
    const optionsSituacaoFechamento = [
        { value: 'Todos', label: t('label.all') },
        { value: 'Saldo Credor', label: t('label.credit_balance') },
        { value: 'Saldo Devedor', label: t('label.outstanding_balance') },
    ]
    const handleSituacaoFechamentoChange = (value) => {
        setsituacaoFechamento(value);
    }

    const [list, setlist] = React.useState([]);
    const handleClickPesquisa = () => {
        clearError("mesano");
        var data = getValues();

        if (data.mesano === "") {
            return setError("mesano", t('label.required'));

        }
        if (data.mesano.length !== 7) {
            return setError("mesano", t('error_message.invalid_month_year'));
        }

        let filtro = {
            franquiaId: session.franquiaId,
            mesano: data.mesano,
            estabelecimentoId: estabelecimento,
            tipoaceite: aceiteFechamento,
            situacaoFechamento: situacaoFechamento,
        }

        setloading(true);
        UsePostApi("royalties/filterconfirmacaopagamento", filtro).then(result => {
            setloading(false);
            if (result.status !== 200) {
                showNotification(result.message, 'danger');
                return false;
            }
            if (result.data.length === 0) {
                showNotification(t('information_message.no_recod_found'), 'warning');
            }
            setlist(result.data);
            setloadingTable(false);
            loadDataCsv(result.data);
        });
    }

    const [observacaoConfirmacao, setobservacaoConfirmacao] = React.useState("");
    const [observacaoInvalida, setobservacaoInvalida] = React.useState(false);

    const sanitizeObservacao = (raw) => raw
        .replace(/[\r\n]+/g, ' ')
        .replace(/<\/?[^>]*>/g, '')
        .replace(/\p{Extended_Pictographic}/gu, '')
        .replace(/[^a-zA-Z0-9À-ÿ\s.,;:!?()-]/g, '');

    const buildConfirmAlert = (data, observacaoValue, hasInvalidChars = false) => {
        const isWideScreen = typeof window !== 'undefined' && window.innerWidth > 767;
        const modalStyle = (data.mode === "advance" && isWideScreen)
            ? { width: 620, maxWidth: '95vw', marginLeft: -310 }
            : undefined;

        return (
        <SweetAlert
            warning={true}
            title={t('label.attention')}
            style={modalStyle}
            customClass={confirmClasses.messageOverride}
            showConfirm={data.mode !== "advance"}
            showCancel={data.mode !== "advance"}
            confirmBtnText={data.confirmText}
            cancelBtnText={data.cancelText}
            cancelBtnBsStyle={"secondary"}
            confirmBtnBsStyle={"danger"}
            confirmBtnCssClass={confirmClasses.actionButton}
            cancelBtnCssClass={confirmClasses.actionButton}
            onConfirm={() => enviaConfirmacaoPagamento(data.tipo, data.lancarTaxa, data.royaltieId, observacaoValue)}
            onCancel={() => setalert(null)}
        >
            <p>{data.msg}</p>
            <TextField
                fullWidth
                multiline
                rows={3}
                variant="outlined"
                label={t('label.observation')}
                value={observacaoValue}
                onChange={(e) => handleObservacaoConfirmacaoChange(data, e.target.value)}
                onKeyDown={(e) => { if (e.key === 'Enter') e.preventDefault(); }}
                inputProps={{ maxLength: 200 }}
                error={hasInvalidChars}
                helperText={hasInvalidChars
                    ? t('error_message.observation_invalid_chars')
                    : `${observacaoValue.length}/200`}
            />
            {data.mode === "advance" &&
                <div className={confirmClasses.buttonsRow} style={{ marginTop: 20 }}>
                    <button
                        type="button"
                        className={"btn btn-lg btn-default " + confirmClasses.actionButton}
                        onClick={() => setalert(null)}
                    >
                        {t('button.cancel')}
                    </button>
                    <button
                        type="button"
                        className={"btn btn-lg btn-secondary " + confirmClasses.actionButton}
                        onClick={() => enviaConfirmacaoPagamento(data.tipo, false, data.royaltieId, observacaoValue)}
                    >
                        {data.cancelText}
                    </button>
                    <button
                        type="button"
                        className={"btn btn-lg btn-danger " + confirmClasses.actionButton}
                        onClick={() => enviaConfirmacaoPagamento(data.tipo, data.lancarTaxa, data.royaltieId, observacaoValue)}
                    >
                        {data.confirmText}
                    </button>
                </div>
            }
        </SweetAlert>
        );
    };

    const handleObservacaoConfirmacaoChange = (data, rawValue) => {
        const value = sanitizeObservacao(rawValue);
        const hasInvalidChars = value !== rawValue;
        setobservacaoConfirmacao(value);
        setobservacaoInvalida(hasInvalidChars);
        setalert(buildConfirmAlert(data, value, hasInvalidChars));
    }

    const handleProcessarConfirmacao = (tipo, royaltieId) => {
        if (list.length === 0) {
            showNotification(t('error_message.select_establishments'), 'warning');
            return;
        }
        let mode = "normal";
        let msg = "";
        let confirmText = t('label.confirm');
        let cancelText = t('button.cancel');
        let lancarTaxa = false;
        if (tipo === "Pagamento") {
            if (list.filter((f) => (f.statusPagamento === "Aguardando OK" && f.parcelas === 1)).length > 0) {
                mode = "advance";
                lancarTaxa = true;
                msg = t('royaltie.message_advance_money');
                confirmText = t('royaltie.launch_rate');
                cancelText = t('royaltie.confirm_no_rate');
            }
            else
                msg = t('royaltie.message_confirm_royaltie_payment');
        }
        else if (tipo == "Recebimento")
            msg = t('royaltie.message_confirm_royaltie_receipt');
        else
            msg = t('royaltie.message_confirm_royaltie_extend_receipt');

        const data = { tipo, royaltieId, lancarTaxa, msg, confirmText, cancelText, mode };
        setobservacaoConfirmacao("");
        setobservacaoInvalida(false);
        setalert(buildConfirmAlert(data, ""));
    }

    const enviaConfirmacaoPagamento = (tipo, lancarTaxa, royaltieId, observacao) => {
        let endpoint = "royalties/";
        if (tipo === "Pagamento")
            endpoint += "confirmarpagamentocreditos";
        else if (tipo === "Recebimento")
            endpoint += "confirmarpagamentodebitos";
        else if (tipo === "Repasse")
            endpoint += "confirmarrepasse";

        const dadosconfirmacao = {
            usuarioId: session.id,
            royaltieId: royaltieId,
            lancarTaxa: lancarTaxa,
            observacaoPagamento: observacao || ""
        }

        setloading(true);
        UsePostApi(endpoint, dadosconfirmacao).then(result => {
            setloading(false);
            if (result.status !== 200) {
                showAlert(result.message, "danger");
                return false;
            }

            let itemConfirm = list.filter((f) => f.royaltieId === royaltieId)[0];

            itemConfirm.statusPagamento = "Confirmação Efetuada";
            itemConfirm.observacaoPagamento = observacao || "";
            let newList = list.map(m => m.royaltieId == royaltieId ? itemConfirm : m);
            setlist(newList);

            showAlert(t('royaltie.confirmation_successfully_executed') + " " + result.data, "success");

            // A confirmação pode gravar o aceite (data, parcelas e valor): recarrega a linha com os dados da API
            handleClickPesquisa();
        });
    }

    const [showModal, setshowModal] = React.useState(false);
    const [royaltieIdExtrato, setroyaltieIdExtrato] = React.useState(0);
    const showExtrato = (idRoyaltie) => {
        setroyaltieIdExtrato(idRoyaltie);
        setshowModal(true);
    }

    const [showModalObservacao, setshowModalObservacao] = React.useState(false);
    const [observacaoDetalhe, setobservacaoDetalhe] = React.useState("");
    const handleViewObservacao = (observacao) => {
        setobservacaoDetalhe(observacao);
        setshowModalObservacao(true);
    }

    const [showModalHistorico, setshowModalHistorico] = React.useState(false);
    const [historicoRoyaltie, sethistoricoRoyaltie] = React.useState([]);

    const handleHistorico = (royaltieId) => {
        UseGetApiSimple("royalties/getHistoricoRoyaltie/" + royaltieId).then(result => {
            if (result.status !== 200) {
                showNotification(result.message, 'danger');
                return false;
            }
            const dadosHistorico = result.data;
            const stories = [];
            let bside = false;
            for (let i = 0; i < dadosHistorico.length; i++) {
                bside = !bside;
                let dtlog = "";
                if (dadosHistorico[i].data !== null)
                    dtlog = formateDateandTime(dadosHistorico[i].data);

                let badgeColor = "info";
                if (dadosHistorico[i].tipoAcao === "Fechamento da Rede")
                    badgeColor = "success";
                else if (dadosHistorico[i].tipoAcao === "Estorno")
                    badgeColor = "warning";
                else if (dadosHistorico[i].tipoAcao === "Fechamento da Unidade")
                    badgeColor = "primary";
                else if (dadosHistorico[i].tipoAcao === "Reprocessamento")
                    badgeColor = "info";
                else if (dadosHistorico[i].tipoAcao === "Confirmação de Pagamento")
                    badgeColor = "success";
                else if (dadosHistorico[i].tipoAcao === "Prorrogação de Recebimento")
                    badgeColor = "warning";
                else if (dadosHistorico[i].tipoAcao === "Confirmar Aceite")
                    badgeColor = "success";
                else if (dadosHistorico[i].tipoAcao === "Confirmar Recebimento")
                    badgeColor = "info";
                
                stories.push({
                    inverted: bside,
                    badgeColor: badgeColor,
                    titleColor: badgeColor,
                    badgeIcon: HistoryIcon,
                    title: dadosHistorico[i].tipoAcao,
                    body: (
                        <div>
                            <b>Data: </b> {dtlog}
                            <br />
                            <b>Usuário:</b> {dadosHistorico[i].nomeUsuario}
                            <br />
                            <b>Motivo:</b> {dadosHistorico[i].motivo}
                        </div>
                    )
                });
            }
            sethistoricoRoyaltie(stories);
            setshowModalHistorico(true);
        });
    };

    // *******************************************************************************
    // ********************************** CABEÇALHO CSV **********************************
    // *******************************************************************************

    const columnsCSV = [
        { displayName: "Estabelecimento", id: "estabelecimentoDescricao" },
        { displayName: "Status", id: "statusPagamento" },
        { displayName: "DataAceite", id: "dataAceite" },
        { displayName: "parcelas", id: "parcelas" },
        { displayName: "Tipo Movimento", id: "tipoMovimento" },
        { displayName: "Valor Pagamento", id: "valorPagamento" },
        { displayName: "Observacao", id: "observacao" }
    ];

    // *******************************************************************************
    // ************************** CARREGAR ITENS DO CSV ****************s*************
    // *******************************************************************************

    const [dataCSV, setdataCSV] = React.useState([]);
    const [loadingTable, setloadingTable] = React.useState(false);

    const loadDataCsv = (data) => {
        let dtCsv = [];

        data.map(item => {
            const valorFormatado =
                item.valorPagamento != null
                    ? "R$ " + item.valorPagamento.toFixed(2).replace('.', ',')
                    : "";
            var obj = {
                estabelecimentoDescricao: item.estabelecimentoDescricao,
                statusPagamento: item.statusPagamento,
                dataAceite: item.dataAceite,
                parcelas: item.parcelas,
                tipoMovimento: item.tipoMovimento,
                valorPagamento: valorFormatado,
                observacao: item.observacaoPagamento || "",
            };
            dtCsv.push(obj);
        })

        setdataCSV(dtCsv);
    }

    let columnsProps = [
        {
            Header: t('label.establishment'),
            accessor: "estabelecimentoDescricao",
        },
        {
            Header: t('label.status'),
            accessor: "statusPagamento",
        },
        {
            Header: t('label.dt_accept'),
            accessor: "dataAceite",
        },
        {
            Header: t('label.parcels'),
            accessor: "parcelas",
        },
        {
            Header: t('sale.type'),
            accessor: "tipoMovimento",
        },
        {
            Header: t('label.value'),
            accessor: "valorPagamento",
            Cell: (props) => {
                if (props.value == null) return "";
                return Math.abs(props.value)
                    .toFixed(2)
                    .replace('.', ',');
            }
        },
        {
            Header: t('label.observation'),
            accessor: "observacaoPagamento",
            sortable: false,
            filterable: false,
            Cell: (props) => (
                props.value
                    ? <Button size="sm" round color="info" onClick={() => handleViewObservacao(props.value)}>
                        Ver
                    </Button>
                    : null
            )
        },
    ]

    const columnsAcao = [
        {
            Header: "Ações",
            Cell: row => (
                <div className="actions-right">
                    {row.original.statusPagamento !== "Confirmação Efetuada" &&
                        <div>
                            {
                                (
                                    (row.original.tipoMovimento === " " ||
                                        row.original.tipoMovimento === "Saldo Credor") &&
                                    row.original.statusPagamento !== "Estornado"
                                ) &&
                                <Button
                                    justIcon
                                    round
                                    simple
                                    color="danger"
                                    className="edit"
                                    onClick={() => handleProcessarConfirmacao("Pagamento", row.original.royaltieId)}
                                >
                                    <Tooltip title={t('royaltie.confirm_payment')} id="tooltip-top" placement="top" classes={{ tooltip: classes.tooltip }} >
                                        <MoneyOffIcon />
                                    </Tooltip>
                                </Button>
                            }
                            {" "}
                            {
                                (
                                    row.original.tipoMovimento === "Saldo Devedor" &&
                                    row.original.statusPagamento !== "Estornado"
                                ) &&
                                <Button
                                    justIcon
                                    round
                                    simple
                                    color="success"
                                    className="edit"
                                    onClick={() => handleProcessarConfirmacao("Recebimento", row.original.royaltieId)}
                                >
                                    <Tooltip title={t('royaltie.confirm_receipt')} id="tooltip-top" placement="top" classes={{ tooltip: classes.tooltip }} >
                                        <LocalAtmIcon />
                                    </Tooltip>
                                </Button>
                            }
                            {" "}
                            {
                                (
                                    row.original.tipoMovimento === "Saldo Devedor" ||
                                    row.original.tipoMovimento === "Saldo Credor" ||
                                    row.original.statusPagamento !== "Estornado"
                                )
                                &&
                                <Button
                                    justIcon
                                    round
                                    simple
                                    color="info"
                                    className="edit"
                                    onClick={() => handleProcessarConfirmacao("Repasse", row.original.royaltieId)}
                                >
                                    <Tooltip title={t('royaltie.extend_receipt')} id="tooltip-top" placement="top" classes={{ tooltip: classes.tooltip }} >
                                        <CallMadeIcon />
                                    </Tooltip>
                                </Button>
                            }
                            {" "}
                        </div>
                    }
                    {
                        row.original.statusPagamento !== "Estornado" &&
                        <Button
                            justIcon
                            round
                            simple
                            color="info"
                            className="edit"
                            onClick={e => { showExtrato(row.original.royaltieId) }}
                        >
                            <Tooltip title={t('register.royalties_extract')} id="tooltip-top" placement="top" classes={{ tooltip: classes.tooltip }} >
                                <Assignment />
                            </Tooltip>
                        </Button>
                    }
                    {" "}
                    <Button
                        justIcon
                        round
                        simple
                        color="default"
                        className="edit"
                        onClick={e => { handleHistorico(row.original.royaltieId) }}
                    >
                        <Tooltip title={"Histórico de Royalties"} id="tooltip-top" placement="top" classes={{ tooltip: classes.tooltip }} >
                            <AccessTimeIcon style={{ color: "black" }} />
                        </Tooltip>
                    </Button>
                </div>
            ),
            sortable: false,
            filterable: false
        }
    ];

    let columns = [...columnsProps, ...columnsAcao];

    return (
        <div className="maxContent">
            <form className="no-print">
                <div>
                    <div>
                        {loading &&
                            <div className="carregandoCmp">
                                <div className="box">
                                    <label>{t('label.loading')}...</label>
                                    <CircularProgress />
                                </div>
                            </div>
                        }
                        {alert}
                        <GridContainer>
                            <GridItem xs={12} sm={12} md={12}>
                                <Card>
                                    <CardHeader color="primary" icon>
                                        <CardIcon color="primary">
                                            <PlaylistAddCheckIcon />
                                        </CardIcon>
                                        <h4 className={classes.cardIconTitle}>
                                            {t('royaltie.royalties_payment_confirmation')}
                                        </h4>
                                    </CardHeader>
                                    <CardBody>
                                        <GridContainer>
                                            <GridItem xs={12} sm={6} md={2}>
                                                <FormControl fullWidth className={classes.formControl}>
                                                    <TextField
                                                        error={errors.mesano ? true : false}
                                                        variant="outlined"
                                                        inputRef={register({ required: t('label.required') })}
                                                        label={t('label.month_year') + " *"}
                                                        name="mesano"
                                                        InputProps={{ inputComponent: MaskMonthYear }}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                    {errors.mesano &&
                                                        <FormHelperText>
                                                            <span className="obg"> {errors.mesano.message}</span>
                                                        </FormHelperText>}
                                                </FormControl>
                                            </GridItem>
                                            <GridItem xs={12} sm={6} md={5}>
                                                <FormControl fullWidth className={classes.formControl}>
                                                    <label className={errors.estabelecimento ? "select__label select__label_error" : "select__label"}>
                                                        {t('label.establishment')}</label>
                                                    <Select
                                                        classNamePrefix="select"
                                                        styles={ValidSelect(errors.estabelecimento ? true : false)}
                                                        isSearchable={true}
                                                        isLoading={isLoadingEstabelecimento}
                                                        name="estabelecimento"
                                                        placeholder={t('label.all') + "..."}
                                                        options={estabelecimentos}
                                                        value={estabelecimentos.filter(({ estabelecimentoId }) => estabelecimentoId === estabelecimento)}
                                                        getOptionLabel={({ descricao }) => descricao}
                                                        getOptionValue={({ estabelecimentoId }) => estabelecimentoId}
                                                        onChange={(value) => handleEstabelecimentoChange(value.estabelecimentoId !== null ? value.estabelecimentoId : "")}
                                                        ref={() => register({ name: "estabelecimento" })
                                                        }
                                                    />
                                                    {errors.estabelecimento &&
                                                        <FormHelperText>
                                                            <span className="obg"> {t('label.required')} </span>
                                                        </FormHelperText>}
                                                </FormControl>
                                            </GridItem>
                                            <GridItem xs={12} sm={6} md={5}>
                                                <FormControl fullWidth className={classes.formControl}>
                                                    <label className={"select__label"}>{t('royaltie.closing_acceptance')}</label>
                                                    <Select
                                                        classNamePrefix="select"
                                                        styles={ValidSelect(errors.aceitefechamento ? true : false)}
                                                        isSearchable={true}
                                                        options={optionsAceiteFechamento}
                                                        name="aceitefechamento"
                                                        value={optionsAceiteFechamento.filter(({ value }) => value === aceiteFechamento)}
                                                        onChange={(option) => handleAceiteFechamentoChange(option.value !== null ? option.value : "Todos")}
                                                        placeholder={t('label.all')}
                                                        ref={() => register({ name: "aceitefechamento" })}
                                                    />
                                                </FormControl>
                                            </GridItem>
                                            <GridItem xs={12} sm={6} md={4}>
                                                <FormControl fullWidth className={classes.formControl}>
                                                    <label className={errors.situacaoFechamento ? "select__label select__label_error" : "select__label"}>
                                                        {t('label.closing_situation')}</label>
                                                    <Select
                                                        classNamePrefix="select"
                                                        styles={ValidSelect(errors.situacaoFechamento ? true : false)}
                                                        isSearchable={true}
                                                        name="situacaofechamento"
                                                        options={optionsSituacaoFechamento}
                                                        value={optionsSituacaoFechamento.filter(({ value }) => value === situacaoFechamento)}
                                                        onChange={(option) => handleSituacaoFechamentoChange(option.value !== null ? option.value : "Todos")}
                                                        placeholder={t('label.all')}
                                                        ref={() => register({ name: "situacaofechamento" })}
                                                    />
                                                </FormControl>
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={2}>
                                                <Button round color="primary" onClick={() => handleClickPesquisa()} >
                                                    {t('label.search')}
                                                </Button>
                                            </GridItem>
                                            <GridItem md={12}>
                                                {notification.show &&
                                                    <div><br />
                                                        <SnackbarContent
                                                            message={notification.message}
                                                            color={notification.color}
                                                            closeNotification={() => setNotification(prev => ({ ...prev, show: false }))}
                                                            close
                                                        /></div>}
                                            </GridItem>
                                        </GridContainer>
                                        <GridContainer>
                                            <GridItem xs={12} sm={12} md={12}>

                                                {dataCSV.length > 0 &&

                                                    <div>
                                                        <div style={{ float: 'right' }}>
                                                            <CsvDownloader
                                                                filename="PagamentoRoyalties"
                                                                columns={columnsCSV}
                                                                datas={dataCSV}
                                                                separator={";"}>
                                                                <Button round color="default" size="sm" >CSV</Button>
                                                            </CsvDownloader>
                                                        </div><div style={{ clear: 'both' }}></div>
                                                    </div>
                                                }
                                            </GridItem>
                                        </GridContainer>
                                        <GridContainer>
                                            <br />
                                            <GridItem xs={12} sm={12} md={12}>
                                                <ReactTable
                                                    loading={loading}
                                                    data={list}
                                                    columns={columns}
                                                    filterable
                                                    defaultFilterMethod={noCaseSensitive}
                                                    defaultPageSize={10}
                                                    minRows={5}
                                                    showPaginationBottom={true}
                                                    className="-striped -highlight"
                                                    previousText={t('button.previous')}
                                                    nextText={t('button.next')}
                                                    loadingText={t('label.loading') + "..."}
                                                    noDataText={t('information_message.no_records_found') + "!"}
                                                    pageText={t('label.page')}
                                                    ofText={t('label.of')}
                                                    rowsText={t('label.rows')}
                                                />
                                            </GridItem>
                                        </GridContainer>
                                    </CardBody>
                                </Card>
                            </GridItem>
                        </GridContainer>
                    </div>
                </div>
            </form>
            {showModal &&
                <Dialog
                    classes={{ root: classes.center + " " + classes.modalRoot, paper: classes.modal + ' ' + classes.modalLarge }}
                    open={showModal}
                    keepMounted
                    onClose={() => setshowModal(false)}
                    aria-labelledby="classic-modal-slide-title"
                    aria-describedby="classic-modal-slide-description"
                >
                    <DialogTitle
                        id="classic-modal-slide-title"
                        disableTypography
                        className={classes.modalHeader}
                        style={{ background: '#5c4477' }}
                    >
                        <Button
                            justIcon
                            className={classes.modalCloseButton}
                            key="close"
                            aria-label="Close"
                            color="transparent"
                            onClick={() => setshowModal(false)}
                        >
                            <Close className={classes.modalClose} />
                        </Button>
                        <h4 className={classes.modalTitle} style={{ color: 'white' }}>{t('register.royalties_extract')} </h4>
                    </DialogTitle>
                    <DialogContent id="classic-modal-slide-description"
                        className={classes.modalBody} style={{ background: '#f0f0f0' }}
                    >
                        <br />
                        {
                            session.franquiaId === 3 ?
                                <ExtratoRoyaltiesDM2 royaltieId={royaltieIdExtrato}></ExtratoRoyaltiesDM2> :
                                <ExtratoRoyalties royaltieId={royaltieIdExtrato}></ExtratoRoyalties>
                        }
                    </DialogContent>
                </Dialog>
            }
            <Dialog
                classes={{ root: classes.center + " " + classes.modalRoot, paper: classes.modal + ' ' + classes.modalLarge }}
                open={showModalHistorico}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => setshowModalHistorico(false)}
                aria-labelledby="classic-modal-slide-title"
                aria-describedby="classic-modal-slide-description"
            >
                <DialogTitle
                    id="classic-modal-slide-title"
                    disableTypography
                    className={classes.modalHeader}
                    style={{ background: '#5c4477' }}
                >
                    <Button
                        justIcon
                        className={classes.modalCloseButton}
                        key="close"
                        aria-label="Close"
                        color="transparent"
                        onClick={() => setshowModalHistorico(false)}
                    >
                        <Close className={classes.modalClose} />
                    </Button>
                    <h4 className={classes.modalTitle} style={{ color: 'white' }}>Histórico de Royalties </h4>
                </DialogTitle>
                <DialogContent id="classic-modal-slide-description"
                    className={classes.modalBody} style={{ background: '#f2f2f2' }}
                >
                    <Timeline stories={historicoRoyaltie} />
                </DialogContent>
            </Dialog>
            <Dialog
                classes={{ root: classes.center + " " + classes.modalRoot, paper: classes.modal }}
                open={showModalObservacao}
                keepMounted
                onClose={() => setshowModalObservacao(false)}
                aria-labelledby="observacao-dialog-title"
                aria-describedby="observacao-dialog-description"
            >
                <DialogTitle
                    id="observacao-dialog-title"
                    disableTypography
                    className={classes.modalHeader}
                    style={{ background: '#5c4477' }}
                >
                    <Button
                        justIcon
                        className={classes.modalCloseButton}
                        key="close"
                        aria-label="Close"
                        color="transparent"
                        onClick={() => setshowModalObservacao(false)}
                    >
                        <Close className={classes.modalClose} />
                    </Button>
                    <h4 className={classes.modalTitle} style={{ color: 'white' }}>{t('label.observation')} </h4>
                </DialogTitle>
                <DialogContent id="observacao-dialog-description" className={classes.modalBody}>
                    <p style={{ whiteSpace: 'pre-wrap' }}>{observacaoDetalhe}</p>
                </DialogContent>
            </Dialog>
        </div>
    );
}